export const ESSearchHeader = { 'x-es-search': 'true' };
